import Vue from 'vue'
import Router from 'vue-router'
import {isLogin} from "../util/globalConfig";
import Login from "../pages/Login";
import QuizList from "../pages/QuizLists";
import NotFound from "../pages/NotFound";
import QuizDetail from "../pages/QuizDetail";
import WinnerList from "../pages/WinnerList";
import Chat from "../pages/Chat";
import { Miniapp } from '../util/Miniapp';

Vue.use(Router);
const Rout = new Router({
    mode: 'history',

    routes: [
        {
            path: '*',
            meta: {
                public: true,
            },
            redirect: {
                path: '/404'
            }
        },
        {
            path: '/404',
            meta: {
                public: true,
            },
            name: 'NotFound',
            component: NotFound
        },
        {
            path: '/',
            name: 'Root',
            redirect: {
                name: getName('Home')
            }
        },
        {
            path: '/',
            name: 'Home',
            component: QuizList
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            meta: {isLoginRequired: false},
            path: '/quiz',
            name: 'QuizList',
            component: QuizList
        },
        {
            meta: {isLoginRequired: false},
            path: '/:questionId/detail',
            name: 'QuizDetail',
            component: QuizDetail
        },
        {
            meta: {isLoginRequired: true},
            path: '/:questionId/winners',
            name: 'winnerList',
            component: WinnerList
        },
        {
            meta: { isLoginRequired: true},
            path: '/chat/:uuid',
            name: 'Chat',
            component:Chat
        }
    ]
});

Rout.beforeEach((to, from, next) => {
    if (to.meta.isLoginRequired === true) {
        if (Miniapp.getIsLoggedIn()) {
            next();
        } else {
            next(from);
        }
    } else {
        next()
    }

});

function getName(name) {
    if (Miniapp.getIsLoggedIn() || name==='Home') {
        return name;
    } else {
        return 'Login';
    }
}

export default Rout;
